/**
 * Retorna o pedido
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 26/03/2013
 */

import { DefaultRequest } from 'scripts/api';

Greenmile.Stop = Greenmile.Stop || {};

Greenmile.Stop.Base = function () {

    this.routeId = null;

    this.setRouteId = function (routeId) {
        this.routeId = routeId;
    };

    this.modalForm = null;

    this.show = function () {
        this.modalForm.showModalForm();
    };

    this.stop = null;

    this.setStop = function (stop) {
        this.stop = stop;
    };

    /**
     * Faz algumas modificações no ambiente onde o modal será inserido, nesse caso, modifica
     * o CSS do overlay para que ele se ajuste ao esquema de posicionamento dessa aba.
     */

    this.prepareToCreateForm = function () {

        var util = new Greenmile.Route.ModalUtils();
        util.ajustModalOverlay(this.modalForm.selector);

    };

    this.loadDriverData = function () {

        const that = this;
        const data = {
          criteriaChain: [
            { 
              and: [
                { 
                  attr: "route.id",
                  eq: this.routeId 
                }
              ]
            }
          ]
        };
        const request = new DefaultRequest({
            url: 'RouteDriver/restrictions?criteria={"filters" : ["*","driver.name", "driver.id"]}',
            method: 'post',
            data,
            success: function (data) {

                that.populateDriversList(data);

            }
        });
        request.send();

    };

    this.successCallbackAppendCollection = true;

    this.successCallback = function () {

        var router = new App.Routers.RouteSummaryStops();
        router.updateGrid(router.getFilter(), Monet.Grid.addDataToGrid, this.successCallbackAppendCollection);

    };

    this.errorCallback = function (data) {

        var monetMessage = new Monet.Form.Messages.AlertMessage();

        monetMessage.setInfoType("error");
        monetMessage.setMessage(JSON.parse(data.responseText));
        monetMessage.triggerMessage();

    };

};